import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmDataService } from '@pages/sm/services/sm-data.service';
import { EventService } from '@core/services/event.service';
import { SmOfflineService } from '@pages/sm/services/sm-offline.service';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.css'],
    standalone: false
})
export class ConfirmationModalComponent implements OnInit {
  @Input() body: any;
  @Input() header: any;

  offlinePostFailList: any;

  private readonly ngbActiveModal = inject(NgbActiveModal);
  private readonly smDataService = inject(SmDataService);
  private readonly eventService = inject(EventService);
  private readonly smOfflineService = inject(SmOfflineService);

  ngOnInit(): void {
    this.smOfflineService.getRecords<any>('SM_OfflineSyncFail').subscribe(records => {
      this.offlinePostFailList = records;
    });
  }

  public cancelClicked(): void {
    this.ngbActiveModal.close();
  }

  public confirmClicked(): void {
    this.ngbActiveModal.close(true);
  }

  public deleteClicked(): void {
    this.smOfflineService.clearObjectStore('SM_OfflineSyncFail').subscribe(() => {
      this.smDataService.haveOfflinePostFail = false;
      this.eventService.broadcast('haveOfflinePostFail', this.smDataService.haveOfflinePostFail);
    });

    const iDsToDelete = this.offlinePostFailList.map((item: any) => item.deleteID);
    this.smOfflineService.deleteRecords('SM_PostCalls', iDsToDelete).subscribe();
    this.ngbActiveModal.close(false);
  }
}
